// Default SortableJS
import Sortable from 'sortablejs'
export const SortableDataTable = {
  bind: function (el, binding, vnode) {
    if ((!binding.hasOwnProperty('value')) || binding.value) {
      let items = vnode.child.items
      const options = {
        animation: 150,
        onUpdate: function (event) {
          vnode.child.$emit('sorted', event, items)
        }
      }
      Sortable.create(el.getElementsByTagName('tbody')[0], options)
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/index.js